/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-disable react/prop-types */
import Button from 'components/base/Button';
import Icon from 'components/icon';
import { Col, Row } from 'react-bootstrap';
import EditEmployeeDetailModal from './EditEmployeeDetailModal';
import useShowModal from 'hooks/custom/useShowModal';
import { formatDate, formatTimeToAmPm } from 'services/utils';
import { currencyFormat } from 'helpers/utils';
import { useNavigate } from 'react-router-dom';
import { hrmsPaths } from 'constants/pagePath';

const dayNames = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

const DetailCardItem = ({ label, value }) => {
  return (
    <div className="mb-2">
      <p className="mb-0 fs-9 ps-1 text-700 text-capitalize">{label}</p>
      <p className="p-1 fs-8 text-1000 ms-1 text-capitalize">{value || '--'}</p>
    </div>
  );
};
const DetailCard = ({ title, children, onEdit }) => {
  return (
    <div className="border border-1 p-2 px-3 rounded-2 mb-3 card">
      <div className="mb-4 pt-2 d-flex align-items-center justify-content-between w-100">
        <div className={'fs-7 text-900 fw-semi-bold text-primary'}>{title}</div>
        <Button
          variant={'phoenix-primary'}
          className="p-1 icon-btn"
          onClick={onEdit}
        >
          <Icon icon="tabler:edit" fontSize="20px" />
        </Button>
      </div>
      <div className="">{children}</div>
    </div>
  );
};
const EmployeeMoreDetail = ({ data }) => {
  const navigate = useNavigate();
  const HideDetail = Number(data.percentage || 0);
  const {
    employee_id,
    first_name,
    last_name,
    father_name,
    mother_name,
    date_of_birth,
    education,
    spouse_name,
    spouse_date_of_birth,
    no_of_children,
    employee_mobile,
    alternate_mobile,
    employee_whatsapp_number,
    employee_email,
    gender,
    marital_status,
    role_name,
    permanent_address,
    current_address,
    blood_group,
    nominee_name,
    manually_punch
  } = data.personal_information || {};
  console.log('🚀 ~ EmployeeMoreDetail ~ manually_punch:', manually_punch);

  const {
    employee_bank_name,
    employee_holder_name,
    employee_account_number,
    employee_bank_ifsc,
    employee_upi_id,
    employee_upi_name,
    last_comment
  } = data.financial_details || {};

  const {
    shift_name,
    start_time,
    end_time,
    branch_name,
    loc_area_name,
    designation_name,
    department_name,
    casual_leave,
    sick_leave,
    category_name,
    working_type,
    week_off,
    date_of_joining,
    date_of_leaving,
    reference,
    experience,
    final_experience,
    notes,
    current_salary,
    last_drown_salary,
    week_off_day
  } = data.professional_details || {};

  const modal = useShowModal();

  let { Aadhar, PAN, ESIC, UAN, Passport, PF } =
    data?.identification_details?.reduce((acc, i) => {
      return {
        ...acc,
        [i.document_type]: i
      };
    }, {}) || {};
  const handleEdit = tab => {
    navigate(`${hrmsPaths.employee.update(employee_id)}?tab=${tab}`, {
      state: {
        returnUrl: `${hrmsPaths.employee.detail(employee_id)}${location.search}`
      }
    });
  };

  return (
    <>
      <h2 className="mb-4">Other Details</h2>
      <div>
        {HideDetail >= 35 && (
          <DetailCard onEdit={() => handleEdit(1)} title={'Personal Details'}>
            <Row>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'First Name'} value={first_name} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'Last Name'} value={last_name} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={"Father's Name"} value={father_name} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={"Mother's Name"} value={mother_name} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Date of Birth'}
                  value={`${formatDate(date_of_birth, 'DD MMM YYYY') || '--'}`}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={"Spouse's Name"}
                  value={spouse_name || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={"Spouse's DOB"}
                  value={`${formatDate(spouse_date_of_birth, 'DD MMM YYYY') || '--'}`}
                />
              </Col>
              {/* <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'No. of Children'}
                  value={no_of_children}
                />
              </Col> */}
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'Education'} value={education || '--'} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'Gender'} value={gender} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Mobile Number'}
                  value={employee_mobile}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Alternate Mobile Number'}
                  value={alternate_mobile || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'WhatsApp Number'}
                  value={employee_whatsapp_number || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Email'}
                  value={employee_email || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Marital Status'}
                  value={marital_status || '--'}
                />
              </Col>

              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Nominee Name'}
                  value={nominee_name || '--'}
                />
              </Col>

              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Blood Group'}
                  value={blood_group || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'Role'} value={role_name || '--'} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Manual Punch'}
                  value={manually_punch == 1 ? 'Allow' : 'Not Allow' || '--'}
                />
              </Col>
              <Col xs={12} sm={12}>
                <DetailCardItem
                  label={'Current Address'}
                  value={current_address || '--'}
                />
              </Col>
              <Col xs={12} sm={12}>
                <DetailCardItem
                  label={'Permanent Address'}
                  value={permanent_address || '--'}
                />
              </Col>
            </Row>
          </DetailCard>
        )}

        {HideDetail >= 65 && (
          <DetailCard onEdit={() => handleEdit(2)} title={'Financial Details'}>
            <Row>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'UPI Id'}
                  value={employee_upi_id || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'UPI Name'}
                  value={employee_upi_name || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'IFSC COde'}
                  value={employee_bank_ifsc}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Account No.'}
                  value={employee_account_number}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Bank Name'}
                  value={employee_bank_name}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Account Holder Name'}
                  value={employee_holder_name}
                />
              </Col>
            </Row>
          </DetailCard>
        )}
        {HideDetail >= 80 && (
          <DetailCard
            onEdit={() => handleEdit(3)}
            title={'Identification Details'}
          >
            <Row>
              {/* <Col xs={12} sm={6} md={6} lg={4} xl={3}>
              <DetailCardItem label={'License Type'} value={'Regular'} />
            </Col> */}
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'PF Number'}
                  value={PF?.document_identification_number || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'UAN Number'}
                  value={UAN?.document_identification_number || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'ESIC Number'}
                  value={ESIC?.document_identification_number || '--'}
                />
              </Col>

              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Passport Number'}
                  value={Passport?.document_identification_number || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Passport Expiry Date'}
                  value={`${Passport?.document_expiry_date ? formatDate(Passport?.document_expiry_date, 'DD MMM YYYY', false) : '--'}`}
                />
              </Col>

              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Aadhaar Number'}
                  value={Aadhar?.document_identification_number}
                />
              </Col>

              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'PAN Number'}
                  value={PAN?.document_identification_number}
                />
              </Col>
            </Row>
          </DetailCard>
        )}
        {HideDetail >= 90 && (
          <DetailCard
            onEdit={() => handleEdit(4)}
            title={'Professional Details'}
          >
            <Row>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Previous Experience'}
                  value={`${experience} Years`}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Total Experience'}
                  value={`${final_experience}`}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'Refrence'} value={reference || '--'} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Last Drown Salary'}
                  value={
                    last_drown_salary ? currencyFormat(last_drown_salary) : '--'
                  }
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Current Salary'}
                  value={current_salary ? currencyFormat(current_salary) : '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Date of Joining'}
                  value={formatDate(date_of_joining, 'DD MMM YYYY') || '--'}
                />
              </Col>

              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Date of Leaving'}
                  value={formatDate(date_of_leaving, 'DD MMM YYYY') || '--'}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'Location'} value={loc_area_name} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'Branch'} value={branch_name} />
              </Col>
              {/* <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'Shift'} value={shift_name} />
              </Col> */}
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Shift'}
                  value={
                    <>
                      {shift_name} <br />
                      <small>
                        ({formatTimeToAmPm(start_time)} -{' '}
                        {formatTimeToAmPm(end_time)})
                      </small>
                    </>
                  }
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'Department'} value={department_name} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Designation'}
                  value={designation_name}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Skill Category'}
                  value={category_name}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem label={'Working Type'} value={working_type} />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Week Of'}
                  value={
                    week_off === 'once_in_week'
                      ? `On ${dayNames[Number(week_off_day || 0) - 1] || '--'}`
                      : week_off?.replaceAll('_', ' ')
                  }
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Allowed Casual Leave'}
                  value={casual_leave}
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={4} xl={3}>
                <DetailCardItem
                  label={'Allowed Sick Leave'}
                  value={sick_leave}
                />
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <DetailCardItem label={'Note'} value={notes || '--'} />
              </Col>
            </Row>
          </DetailCard>
        )}
      </div>
      <EditEmployeeDetailModal
        show={modal.isOpen}
        handleClose={modal.handleCloseModal}
        data={modal.modalData}
      />
    </>
  );
};

export default EmployeeMoreDetail;
